export const parseDateOnly = (dateInput: string | Date): Date => {
  const dateString =
    dateInput instanceof Date ? dateInput.toISOString() : dateInput;
  const dateOnly = dateString.split("T")[0];
  return new Date(dateOnly + "T00:00:00");
};
